import { render, staticRenderFns } from "./PurchasingRequestModal.vue?vue&type=template&id=e01c45d4&"
import script from "./PurchasingRequestModal.vue?vue&type=script&lang=js&"
export * from "./PurchasingRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports